import React, { ReactNode, useCallback, useEffect, useState } from 'react';
import cx from 'clsx';

import style from './index.module.scss';

type Props = {
  children?: ReactNode;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
};

export const Switch = ({ children, checked, onChange, disabled }: Props) => {
  const [isChecked, setChecked] = useState(checked);

  useEffect(() => {
    if (checked) {
      setChecked(checked);
    }
  }, [checked]);

  const handleClick = useCallback(() => {
    if (disabled) {
      return;
    }
    const next = !isChecked;
    setChecked(next);
    onChange?.(next);
  }, [onChange, isChecked, disabled]);

  return (
    <label
      className={cx(style.dbSwitch, isChecked && style.isChecked, disabled && style.isDisabled)}
      onClick={handleClick}>
      <span className={style.indicator} />
      {children}
    </label>
  );
};
